import Loancalculationdocs from "../../../jsx/components/Dashboard/LoanCalculation/LoanCalculationDocs/loancalculationdocs";

const LoanCalculationDocsWrapper = () => {
  return <Loancalculationdocs />;
};

export const allowedRoles = [_enum.ROUTE_PERSONAS.customer];
export default constore(LoanCalculationDocsWrapper);
